module.exports = __webpack_public_path__ + "static/img/3areaB_1.5d21f8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_1.png
// module id = 1151
// module chunks = 1